import { useNavigate } from "react-router-dom";
import { SearchForm } from "../components/SearchForm";

export function HomePage() {
  const navigate = useNavigate();
  return (
    <main className="home-page">
      <div className="home-grid" aria-hidden="true" />
      <header className="home-header"><a className="brand" href="/" aria-label="DEFYND home">DEFYND<span>.</span></a><span>VALORANT TRACKER</span></header>
      <section className="search-hero">
        <p className="kicker"><span /> PLAYER INTELLIGENCE</p>
        <h1><span>DEFYND</span><br />VALORANT</h1>
        <p className="hero-copy">Search any Riot account. Read the match, not the noise.</p>
        <SearchForm onSearch={(gameName, tagLine) => navigate(`/player/${encodeURIComponent(gameName)}/${encodeURIComponent(tagLine)}`)} />
        <p className="demo-note"><span>DEMO</span> Live Riot access activates when a production API key is configured.</p>
      </section>
      <footer className="home-footer"><span>PERFORMANCE, DECODED.</span><span>DEFYND © {new Date().getFullYear()}</span></footer>
    </main>
  );
}
